var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"metamaskLogin",attrs:{"variant":"none"},on:{"click":_vm.onConnectMetaMask}},[_vm._v(" "+_vm._s(_vm.isBuy ? 'Login' : 'Login with Meta mask')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }